import type { RouteRecordRaw } from 'vue-router';

import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';

import TemplateList from '@views/Document/Template/TemplateList.vue';
import BrochureTemplateDetail from '@views/Document/Template/BrochureTemplateDetail.vue';
import TemplateDetail from '@views/Document/Template/TemplateDetail.vue';
import DocumentList from '@views/Document/Document/DocumentList.vue';
import BrochureGenerate from '@views/Document/Document/BrochureGenerate.vue';
import DocumentGenerate from '@views/Document/Document/DocumentGenerate.vue';

import WrapperView from '@views/WrapperView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/document/template',
        name: 'documentTemplateList',
        components: {
            default: TemplateList,
        },
    },
    {
        path: '/document/template/brochure/create',
        name: 'documentTemplateCreateBrochure',
        components: {
            default: BrochureTemplateDetail,
        },
    },
    {
        path: '/document/template/brochure/:templateId',
        name: 'documentTemplateEditBrochure',
        components: {
            default: BrochureTemplateDetail,
        },
        props: {
            default: (route) => ({
                templateId: route.params.templateId,
            }),
        },
    },
    {
        path: '/document/template/:type/create',
        name: 'documentTemplateCreate',
        components: {
            default: TemplateDetail,
        },
        props: {
            default: (route) => ({
                type: route.params.type,
            }),
        },
    },
    {
        path: '/document/template/:templateId',
        name: 'documentTemplateEdit',
        components: {
            default: TemplateDetail,
        },
        props: {
            default: (route) => ({
                templateId: route.params.templateId,
            }),
        },
    },

    {
        path: '/document',
        name: 'document',
        redirect: { name: 'documentList' },
        components: {
            default: WrapperView,
            bar: DefaultBarView,
            rail: DefaultRailView,
        },
        children: [
            {
                path: '/document',
                name: 'documentList',
                components: {
                    default: DocumentList,
                },
            },
            {
                path: '/document/generate/brochure',
                name: 'documentGenerateBrochure',
                components: {
                    default: BrochureGenerate,
                    bar: DefaultBarView,
                    rail: DefaultRailView,
                },
            },
            {
                path: '/document/generate/:type/:leadId',
                name: 'documentGenerate',
                components: {
                    default: DocumentGenerate,
                    bar: DefaultBarView,
                    rail: DefaultRailView,
                },
                props: {
                    default: (route) => ({
                        type: route.params.type,
                        leadId: route.params.leadId,
                    }),
                },
            },
        ],
    },
];

export default routes;
